<template>
  <view class="couponItem">
    <view class="couponHeader">
      <view class="topBtnBox">
      </view>
    </view>
    <view class="couponContent">
      <view class="leftBox">
        <view :class="coupon.couponType == 1 ? 'smallPrice' : 'promoteInfo'">
          <text v-if="coupon.couponType == 1">￥{{ coupon.reduceAmount / 100 }}</text>
          <text v-else>{{ coupon.discount / 10 }}折</text>
        </view>
        <text class="reachPrice" v-if="coupon.couponType == 1">满{{ coupon.reachAmount / 100 }}元使用</text>
      </view>
      <view class="rightBox">
        <view class="couponTitle">{{ coupon.title2 }}</view>
        <view class="couponExpireDate">有效期至{{ coupon.expireDate }}</view>
        <view class="productTypeLimit">{{ coupon.productType2 }}可用</view>
      </view>
      <view class="couponSubInfo">
        <slot></slot>
      </view>
    </view>
    <view class="couponFooter">
    </view>
  </view>
</template>

<script setup>
 
// 定义 props
import { defineProps } from 'vue'
defineProps({
  coupon: {
    type: Object,
    required: true
  }
})
 
</script>

<style scoped>
.couponItem {
  background: linear-gradient(90deg, #fff9f2, #fff0e6);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  position: relative;
  box-shadow: 0 2rpx 10rpx rgba(0, 0, 0, 0.05);
}

.couponHeader {
  height: 20px;
}

.topBtnBox {
  position: absolute;
  right: 20px;
  top: 20px;
}

.couponContent {
  display: flex;
  padding: 20rpx 0;
}

.leftBox {
  width: 180px;
  text-align: center;
  border-right: 1rpx dashed #f6a853;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.smallPrice {
  font-size: 36px;
  font-weight: bold;
  color: #ff6b00;
}

.promoteInfo {
  font-size: 32px;
  font-weight: bold;
  color: #ff6b00;
}

.reachPrice {
  font-size: 20px;
  color: #999;
  margin-top: 10px;
}

.rightBox {
  flex: 1;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.couponTitle {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.couponExpireDate {
  font-size: 20px;
  color: #999;
  margin-bottom: 10px;
}

.productTypeLimit {
  font-size: 20px;
  color: #666;
}

.couponSubInfo {
  position: absolute;
  right: 20px;
  bottom: 20px;
  font-size: 20px;
  color: #999;
}

.couponFooter {
  height: 20px;
}
</style>